const HelpIcon = ({ active }) => {
  const color = active ? "#0149AD" : "#545454";
  return (
    <svg
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="7.5" cy="7" r="6.25" stroke={color} />
      <path
        d="M6.25 5.125C6.25 4.43464 6.80964 3.875 7.5 3.875C8.19036 3.875 8.75 4.43464 8.75 5.125C8.75 5.37384 8.67729 5.60571 8.55195 5.80049C8.17838 6.38105 7.5 6.93464 7.5 7.625V7.9375"
        stroke={color}
        stroke-linecap="round"
      />
      <path
        d="M7.495 10.125H7.50061"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default HelpIcon;
